import { Button } from '@platform/components';
import {
  ApplicationResultContent,
  ApplicationResultStepper,
} from '../../components/ApplicationResultContent';

const steps = [
  {
    label: 'Application submitted',
  },
  {
    label: 'Application aproved',
    content:
      'Congrats! After a review of your application, you meet the requirements to join our network of Experteers.',
  },
  {
    label: 'Get to know your dashboard',
    active: true,
    content:
      "Continue to your new dashboard to see what exciting projects are looking for support, see what's new in Community, and browse organizations.",
  },
  {
    label: 'Introduce yourself',
    content:
      'To get the ball rolling, we recommend sending introductions to at least 3-5 projects that interest you. You can track their status on your My Projects page.',
  },
];
export const IndividualApplicationApproved = () => {
  return (
    <ApplicationResultContent
      title="You're in! What happens next?"
      description={
        <div>
          <ApplicationResultStepper steps={steps} />
          <Button
            variant='primary'
            size='lg'
            additionalClassnames='w-full'
            href={`platform/dashboard`}
          >
            See my dashboard
          </Button>
        </div>
      }
    />
  );
};
